import {getFavoriteCookie} from "@js/globalFunctions/cookieHandling";

export function updateFavoritedHouses()
{
	const favCookie = getFavoriteCookie();
	const removeText = (siteID === "2") ? 'Aus Merkliste löschen' : 'Fjern favorithus';
	
	if( typeof favCookie !== 'undefined' )
	{
		const cookie = JSON.parse(favCookie);
		for( let i = 0; i < cookie.length; i++ )
		{
			$(document).find(".feriehus-item[data-post-id='"+cookie[i]+"'] .fav-link, .fav-link[data-post-id='"+cookie[i]+"']").addClass('hasBeenSelected');
			$(document).find(".feriehus-item[data-post-id='"+cookie[i]+"'] .fav-link .text, .fav-link[data-post-id='"+cookie[i]+"'] .text").text(removeText);
		}
	}
}
